import { useState, useEffect } from "react";

const RobustTools = () => {
  const tools = [
    { name: "HTML5", image: "/images/html5.webp" },
    { name: "CSS3", image: "/images/css3.webp" },
    { name: "BootStrap", image: "/images/bootstrap5.webp" },
    { name: "JavaScript", image: "/images/js.webp" },
    { name: "Reactjs", image: "/images/reactjs.webp" },
    { name: "Nodejs", image: "/images/node.webp" },
    { name: "XML", image: "/images/xml.webp" },
    { name: "JSON", image: "/images/json-file.webp" }
  ];
  const tools1 = [
    { name: "Nextjs", image: "/images/nextjs.webp" },
    { name: "PHP", image: "/images/php.webp" },
    { name: "Laravel", image: "/images/Laravel.webp" },
    { name: "Flutter", image: "/images/flutter.webp" },
    { name: "Dart", image: "/images/dart.webp" },
    { name: "WordPress", image: "/images/wordpress.webp" },
    { name: "MySQL", image: "/images/mysql.webp" },
    { name: "figma", image: "/images/figma.webp" },
    { name: "firebase", image: "/images/firebase.webp" }
  ];

  const [flippedIndex, setFlippedIndex] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * tools.length);
      setFlippedIndex((prev) => (prev === randomIndex ? null : randomIndex));
    }, 3000);
    return () => clearInterval(interval);
  }, [tools.length]);

  return (
    <section className="tools-section m whychooseus">
      <h2 className="fsh2 m0 mb2">Robust Tools & Technologies We Work</h2>
      <div className="tools-grid">
        {tools.map((tool, index) => (
          <div
            key={index}
            className={`tool-card ${flippedIndex === index ? "flipped" : ""}`}
            aria-label={tool.name}
          >
            <div className="tool-content">
              <img
                src={tool.image}
                alt={tool.name}
                loading="lazy"
                className="tool-image"
              />
              <p className="tool-name">{tool.name}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="tools-grid">
        {tools1.map((tool, index) => (
          <div
            key={index}
            className={`tool-card ${flippedIndex === index ? "flipped" : ""}`}
            aria-label={tool.name}
          >
            <div className="tool-content">
              <img
                src={tool.image}
                alt={tool.name}
                loading="lazy"
                className="tool-image"
              />
              <p className="tool-name">{tool.name}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default RobustTools;
